import React from 'react'
import { qualities } from '../../../config/pageContent'
import Image from '../../../Components/Image'
import Text from '../../../Components/Text'
import { Button } from '@mui/material'
import { medias } from '../../../config/Resources'
import { Lock } from '@mui/icons-material'
import { mediaResources } from '../../../config/Constants'
import ReactECharts from 'echarts-for-react';
import { useNavigate } from 'react-router-dom'


const PsychomatricProfileTest = () => {

    const categories = ["Extraversion",'Agreeableness', 'Conscientiousness','Emotional Stability','Openness to Experience'];
    const values = [20, 35, 30, 25, 30];
    const navigate = useNavigate()
    const colors = ['#FC74B5', '#E9C07E', '#FEAA8F', '#99D99F', '#7B80FD'];
    const option = {
        grid: {
            top: 0,      // Set top padding to 0
            bottom: 0,   // Set bottom padding to 0
            left: 0,  // Adjust left padding if needed
            right: 0, // Adjust right padding if needed
            containLabel: true // Make sure labels are contained within the chart
          },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false, // Hide the grid lines
          },
          axisTick: {
            show: false, // Show the yAxis tick marks
          },
          axisLine: {
            show: false, // Show the yAxis line
          },
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            show: true,
            // align: 'left', // Align y-axis labels to the left
            textStyle: {
              color: 'black',       // Set text color
              fontSize: 18,         // Set text font size
              fontWeight: 'bold',   // Set text font weight
              fontFamily: 'Arial',  // Set text font family
            },
          },
          axisLine: {
            show: true, // Show the yAxis line
          },
          axisTick: {
            show: false, // Show the yAxis tick marks
          },
          splitLine: {
            show: false, // Hide the grid lines
          },
        },
        series: [
          {
            type: 'bar',
            data: values,
            barWidth: 28,
            barGap: 25,
            label: {
              show: true,
              
              position: 'right',
              formatter: '{c}',
            },
            itemStyle: {
                borderRadius: [0, 50, 50, 0], // Set borderRadius to make the top rounded
                color: function(params : any) { // Dynamically assign color based on index
                    return colors[params.dataIndex];
                  }
              },
          },
        ],
      };
  return (
    <>
    <div className='bg-white 3xl:mt-[12px] shadow-[0px_5px_16px_rgba(0,0,0,0.06)] 3xl:pt-[30px] py-[28px] rounded-b-[20px] mt-[28px] pt-[60px] px-[37px] desktop:!mt-0'>
      <div className='flex gap-[20px]'>
        {
          qualities.map((items: any) => {
            return <div className='relative flex justify-center '>
                <Image className='desktop:!w-[130px] 3xl:w-[160px]' src={items.icons} alt={`${items.name}`}/>
                <Text className='absolute bottom-[20px] desktop:text-[12px] font-[PlusJakartaSans-Bold] 3xl:bottom-[16px] font-bold'>
                  {items.name}
                </Text>
                  <div className='absolute desktop:bottom-[calc(0%-12px)] bottom-[calc(0%-27px)] '>
                      {items?.isActive ? <Text className='bg-[#2771E7] font-[PlusJakartaSans-Bold] rounded-lg text-white px-[27px] desktop:text-[12px] 3xl:px-[17px] 3xl:py-1 py-[8px]'>Free</Text> : <Text className=' bg-[#E4E4E4] desktop:text-[12px] font-[PlusJakartaSans-Bold] 3xl:py-1 3xl:px-[17px] px-[27px]  rounded-lg py-[8px] '> <Lock className='desktop:!text-[12px]' />  Unlock </Text>}
                  </div>  
            </div>
          } )
        }
      </div>
      {false ? <>
        <div className='mt-[77px] flex flex-col border border-[#70707034] rounded-[22px] w-3/4 py-[20px] px-[23px]'>
        <Text className='text-[29px] font-quitery'>
            Personality
        </Text>
         <ReactECharts
            option={option}
            style={{ height: '300px', width: '100%' }}
            />
        </div>
      </> : <><div className='mt-[77px] 3xl:mt-[50px] flex border border-[#70707034] rounded-[22px] w-1/2 py-[20px] px-[23px]'>
        <div>
            <Text className='font-quitery 3xl:text-[24px] desktop:!text-[20px] text-[29px]'>
              Avail. your Test Now
            </Text>
            <Text className='text-[17px] 3xl:text-[14px] desktop:!text-[12px] text-[##252424] opacity-80'>
              The first project about the health of mobile applications, The first project about the health of
            </Text>
            <Button onClick={()=>navigate("/get-started")} className='!bg-[#239403] 3xl:text-[12px] text-[16px] !capitalize rounded-full mt-2' variant='contained'>
              Get started
            </Button>
        </div>
        <div>
          <Image src={medias.images.Profile.TestNow} />
        </div>
      </div>
      <div className='flex w-full'>
      <div className='mt-[32px] border border-[#70707034] rounded-[22px] w-3/5 py-[20px] px-[23px]'>
        <Text className='text-[23px] 3xl:text-[18px] desktop:!text-[15px] text-[#13110F] font-[PlusJakartaSans-Bold] font-bold '>
        Tips of getting good answers
        </Text>
        <ul className='flex flex-col gap-[16px]  list-disc ml-[14px] text-[#000000] opacity-70    3xl:gap-[12px] 3xl:mt-[12px] mt-[26px]'>
          <li className='font-[PlusJakartaSans-SemiBold]  desktop:!text-[12px] 3xl:text-[14px]'>
            Chat with our counselor
          </li>
          <li className='font-[PlusJakartaSans-SemiBold] desktop:!text-[12px] 3xl:text-[14px]'>
            Get your personalised list of colleges & exams matching your preferences
          </li>
          <li className='font-[PlusJakartaSans-SemiBold] desktop:!text-[12px] 3xl:text-[14px]'>
            Chat with our counselor
          </li>
          <li className='font-[PlusJakartaSans-SemiBold] desktop:!text-[12px] 3xl:text-[14px]'>
            Get your personalised list of colleges & exams matching your preferences
          </li>
        </ul>
      </div>
      <div className='w-1/3 mt-auto ml-auto'>
        <Image src={`${mediaResources}/Profile/CareerCounselling/Coupon.png`} alt="Coupon" />
      </div>
      </div></>}
    </div>
    </>
  )
}

export default PsychomatricProfileTest